import ApiCore from '../utilities/Core';

export const apiLogin = new ApiCore({
    get: false,
    getSingle: false,
    search: false,
    post: true,
    put: false,
    delete: false,
    url: 'account',
    plural: 'account',
    single: 'account',
});
